import type { VeoAutocaptureConfig, VeoPlugin } from '../../types';
import { definePlugin } from '../plugin';
import { DomListener } from './dom-listener';

/**
 * Plugin de autocaptura de eventos del DOM.
 * Captura clicks, submits y changes automáticamente y los emite como
 * eventos `track('$autocapture', …)` por la Queue del cliente.
 */
export function autocapturePlugin(config: VeoAutocaptureConfig = {}): VeoPlugin {
  let listener: DomListener | null = null;

  return definePlugin({
    name: 'autocapture',
    install(client) {
      listener = new DomListener(client, config);
      listener.install();
    },
    destroy() {
      listener?.destroy();
      listener = null;
    },
  });
}

export { DomListener } from './dom-listener';
export type { AutocapturePayload } from './element-serializer';
